module.exports = __webpack_public_path__ + "static/media/team.4193562d.png";